import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { environmentLoader as environmentLoaderPromise } from './environments/environmentLoader';

import * as _ from 'lodash';

environmentLoaderPromise.then((env) => {
    if (env.production) {
        enableProdMode();
    }
    environment.auth = _.defaults({}, env.auth, environment.auth);
    environment.settings = _.defaults({}, env.settings, environment.settings);
    environment.production = _.defaults({}, env.production, environment.production);

    platformBrowserDynamic()
        .bootstrapModule(AppModule, {
            providers: [{ provide: LOCALE_ID, useValue: 'en-US' }],
        })
        .catch((err) => console.log(err));
});
